import api from '@/services';

export const apiGetProfile = async () => {
  return await api.get('/auth/getProfile');
};

export const apiUpdateProfile = async (payload: {
  name?: string;
  profileImage?: File;
}) => {
  const formData = new FormData();
  if (payload.name) {
    formData.append('name', payload.name);
  }
  if (payload.profileImage) {
    formData.append('image', payload.profileImage);
  }

  return await api.put('/auth/editProfile', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const apiSendEmailOtp = async () => {
  return await api.post('/auth/send-otp');
};

export const apiUpdateEmail = async (payload: {
  newEmail?: string;
  otp?: string;
  password?: string;
}) => {
  return await api.post('/user/change-email', payload);
};
export const apiJoinWaitlist = async (payload) => {
  return await api.post('/twin/join-waitList', payload);
};
export const apiMyTwin = async () => {
  return await api.get('/user/my-twin');
};

export const apiGetPointsPackages = async () => {
  return await api.get('/points/packages');
};

export const apiGetStripeFinalPrice = async (payload: {
  productId: string;
}) => {
  return await api.get('/payment/stripe/price', { params: payload });
};

export const apiSendFeedback = async (formData: FormData) => {
  return await api.post('/twin/send-feedback', formData);
};

export const apiGetUserPoints = async (payload: any) => {
  return await api.get('/points', { params: payload });
};

export const apiGetTransactions = async (payload) => {
  return await api.get('/user/transaction-history', { params: payload });
};

export const apiGetVault = async () => {
  return await api.get('/user/vault');
};

export const apiSendInvites = async (payload: { emails: string[] }) => {
  return await api.post('/auth/send-invite', payload);
};

export const apiCheckoutWithTwinToken = async (payload: {
  packageId: string;
  email: any;
}) => {
  return await api.post('/points/add', payload);
};

export const apiCheckTwinNameAvailability = async (payload) => {
  return await api.post('/twin/name-availability', payload);
};

export const apiGetConversationPoints = async (payload: {
  firstPersonalityId: string;
  secondPersonalityId: string;
  conversationType: string;
  topic: string;
  vaultId: string;
  isAudio: boolean;
  ratio: [number, number];
}) => {
  const params = { ...payload, ratio: JSON.stringify(payload.ratio) };
  return await api.get('/points/conversation-points', { params });
};

export const apiDeductPoints = async (payload: {
  email: any;
  points: number;
}) => {
  return await api.post('/points/deduct', payload);
};

export const apiInitiateConversation = async (payload: {
  address: string;
  email: any;
  conversationId: string;
}) => {
  return await api.post('points/initiate-conversation', payload);
};

export const apiGetChatHistory = async (payload: {
  vaultId: string | null;
  page: number;
  limit?: number;
}) => {
  return await api.get(`/twins/get-twintv-chat-history`, {
    params: payload,
  });
};

export const apiGetChatMessages = async (payload: {
  vaultId: string;
  platformId: string;
  pageIndex?: number;
  limit?: number;
}) => {
  return await api.get(`/twins/get-ChatHistory`, {
    params: payload,
  });
};

export const apiGetContextInfo = async (conversationId: string) => {
  const response = await api.get('/conversation/get_context_info', {
    params: { conversationId },
  });
  return response.data;
};

